module.exports = __webpack_public_path__ + "img/el_alquimista-isotipo_azul.7caf959c.svg";